import React, { useState } from "react";
import Option1Authority from "../components/design-previews/Option1Authority";
import Option2Peace from "../components/design-previews/Option2Peace";
import Option3Tactical from "../components/design-previews/Option3Tactical";

const options = [
  { id: "authority", label: "A · Institutional Authority", sub: "Premium · trust-driven", Comp: Option1Authority },
  { id: "peace", label: "B · Community Peace of Mind", sub: "Warm · human", Comp: Option2Peace },
  { id: "tactical", label: "C · Modern Tactical", sub: "High-tech · command center", Comp: Option3Tactical },
];

export default function DesignGallery() {
  const params = new URLSearchParams(window.location.search);
  const initial = options.find((o) => o.id === params.get("opt")) ? params.get("opt") : "authority";
  const [active, setActive] = useState(initial);
  const Active = options.find((o) => o.id === active).Comp;

  const choose = (id) => {
    setActive(id);
    const url = new URL(window.location.href);
    url.searchParams.set("opt", id);
    window.history.replaceState({}, "", url);
  };

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Switcher bar */}
      <div className="sticky top-0 z-50 bg-slate-950/95 backdrop-blur border-b border-white/10" style={{ fontFamily: "'Inter', sans-serif" }}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center gap-3">
          <span className="text-white/50 text-xs uppercase tracking-widest mr-2">Design Options →</span>
          {options.map((o) => (
            <button
              key={o.id}
              data-testid={`design-tab-${o.id}`}
              onClick={() => choose(o.id)}
              className={`text-left px-4 py-2 rounded-lg border transition-all ${
                active === o.id
                  ? "bg-white text-slate-900 border-white"
                  : "bg-white/5 text-white/70 border-white/15 hover:bg-white/10"
              }`}
            >
              <div className="text-sm font-semibold leading-tight">{o.label}</div>
              <div className="text-[11px] opacity-60">{o.sub}</div>
            </button>
          ))}
        </div>
      </div>

      {/* Active preview */}
      <div data-testid="design-preview-canvas">
        <Active />
      </div>
    </div>
  );
}
